import React from 'react';
import { Provider } from 'react-redux';
import { GameApp } from './components/GameApp';
import { uiStore } from './store';
import { TicketsGrantedView } from './components/common/TicketsGrantedView';
import { PopupsUI } from './components/popups';

export const UIOverlay: React.FC = () => {
  return (
    <Provider store={uiStore}>
        <GameApp/>
        <TicketsGrantedView />
        <PopupsUI />
    </Provider>
  );
}; 